import React from "react";

export default function BackIcon({ Classname }) {
    return (
        <svg className={Classname} xmlns="http://www.w3.org/2000/svg" width="26.25px" height="26.25px" viewBox="0 0 24 24" style={{
            fill: 'rgba(255, 255, 255, 1)',
            transform: 'rotate(180deg)', 
            cursor: 'pointer'
            // progid:'DXImageTransform.Microsoft.BasicImage(rotation=2)'
        }}><path d="M21 11H6.414l5.293-5.293-1.414-1.414L2.586 12l7.707 7.707 1.414-1.414L6.414 13H21z"></path></svg>
        
    );
}
